/**
 * MarcaDoSistema — o bloco de marca do topo da barra lateral e da gaveta: logo SVG oficial (o branco no
 * tema escuro) + o nome do sistema em texto pequeno. É um LINK para a home (NAV-09: o logo era um `<div>`).
 * Uma marca por tela (NAV-25: havia três no Sentinela). Nunca o nome do produto escrito no lugar do logo.
 */
import type { ProdutoShell, RenderLinkShell } from "./tipos.js";

export function MarcaDoSistema({ produto, renderLink, aoClicar }: { produto: ProdutoShell; renderLink: RenderLinkShell; aoClicar?: () => void }) {
  return renderLink({
    href: produto.href,
    className: "casca-marca",
    ariaLabel: `${produto.logo.alt} ${produto.nome}: ir para o início`,
    aoClicar,
    children: (
      <>
        <img src={produto.logo.claro} alt="" className="casca-logo casca-logo-claro" />
        <img src={produto.logo.escuro} alt="" className="casca-logo casca-logo-escuro" />
        <span className="casca-marca-nome">{produto.nome}</span>
      </>
    ),
  });
}
